export default __webpack_public_path__ + "static/stadtamthall.uebersicht-09e52c7751bc05426cf76b0655485f70.jpg";